import {Validator} from '../../Core/validator';
import {KeyEvent} from '../../Core/key-events';
import {numberFormat} from "../../Core/common";

let events = null;


const print = (element, price, count) => {

    let priceBox = element.querySelector('.js_item_total_price');
    if(priceBox){
        priceBox.innerHTML = numberFormat(price || 0);
    }
   let without_discount_price = element.querySelector('.js_item_total_without_discount_price');
    if(element.dataset.without_discount_price && without_discount_price && count > 0 ){
        without_discount_price.innerHTML = numberFormat(element.dataset.without_discount_price * count || 0);
    }
    //element.querySelector('.ALL').innerHTML = numberFormat(price)
    let messagebox = element.querySelector('.js_item_message');
    if (messagebox) {
        if (!count) {
            messagebox.classList.remove('d-none');
            messagebox.classList.remove('text-success');
            messagebox.classList.add('text-danger');
            messagebox.innerHTML = "Добавьте или удалите как минимум 1 товар.";
        } else {
            messagebox.classList.add('d-none');
        }
    }
};

const setInputValue = (input, set) => {
    let cnt = input.value;
    set(input);
    if (input.value < 0) {
        input.value = cnt;
    }
    return input.value;
};
const items = new Map();


const setTotal = (options) => {
    if(options.count && options.price){
        options.totalPrice = options.count * options.price;
    }else{
        options.totalPrice = 0;
    }
    return options;
};

const elementInitEvents = (element, input) => {

    const increment = input.closest('.count-number').querySelector('.format_increment');
    const decrement = input.closest('.count-number').querySelector('.format_decrement');

    if (increment) {
        increment.removeEventListener('click', incrementSegment.bind(null, element, input), false);
        increment.addEventListener('click', incrementSegment.bind(null, element, input), false);
    }

    if (decrement) {
        decrement.removeEventListener('click', decrementSegment.bind(null, element, input), false);
        decrement.addEventListener('click', decrementSegment.bind(null, element, input), false);
    }

    input.addEventListener('keydown', inputForSegment.bind(null, element, input));
};

const elementRemoveEvents = (input) => {
    const increment = input.parentNode.querySelector('.format_increment');
    const decrement = input.parentNode.querySelector('.format_decrement');

    if (increment) {
        increment.removeEventListener('click', incrementSegment);
    }

    if (decrement) {
        decrement.removeEventListener('click', decrementSegment);
    }

    input.removeEventListener('keydown', inputForSegment);
};

const deleteItem = item => {
    let list = items.get(item);
    if (list) {
        elementRemoveEvents(list.input);
        items.delete(item);
    }
};

const incrementSegment = (element, input) => calculateCount(setInputValue(input, (input) => input.stepUp()), element, input);

const decrementSegment = (element, input) => calculateCount(setInputValue(input, (input) => input.stepDown()), element, input);

let inputTimer = null;
const inputForSegment = (element, input, evt) => {
    if (!Validator.isNumber(evt.key) &&
        !(
            evt.keyCode === KeyEvent.DOM_VK_BACK_SPACE ||
            evt.keyCode === KeyEvent.DOM_VK_DELETE
        )
    ) {
        evt.preventDefault();
    }

    clearTimeout(inputTimer);
    inputTimer = setTimeout(() => calculateCount(input.value, element, input), 500);
};

const calculateCount = (cnt, element, input) => {

    let currentInput = items.get(element);
    cnt = parseInt(isNaN(cnt) ? 0 : cnt);
    let newInput = setTotal({...currentInput, count: cnt});
    items.set(element, newInput);

    input.value = newInput.count;

    let data = [{count: newInput.count, price: newInput.price, totalPrice: newInput.totalPrice}];

    if (newInput.count) {
        events.dispatch('paper.update', element, [...data]);
    }

    print(element, newInput.totalPrice, newInput.count);
};



const init = itemSelectors => {

    document.querySelectorAll(itemSelectors).forEach(item => {
        let options = {
            count: 0,
            itemId: item.dataset.item || 0,
            totalPrice: 0,
            price: item.dataset.price || 0
        };

        item.querySelectorAll('.js_count_component').forEach(component => {

            elementInitEvents(item, component);
            let cnt = parseInt(isNaN(component.value) ? 0 : component.value);
            options = {...options, count:cnt, input: component};
        });

        items.set(item, setTotal(options));
    });
};
export const calculator = (event) => {
    events = event;
    return {
        init: selector => init(selector),
        delete: item => deleteItem(item),
    };
};